const RoleBasedAccessControlOrigin = Object.freeze({
    frontend : "frontend",
    customer : "customer",
    api : "api"
});

export default RoleBasedAccessControlOrigin;